import { MAIN_SERVER } from '../api/instance'

export const GET_SECTIONS = async () => {
    return MAIN_SERVER({
        method: 'get',
        url: '/templates/sections',
    })
}

export const GET_TEMPLATES = async (customId, params) =>
    MAIN_SERVER({
        method: 'get',
        url: `/templates/sections/${customId}`,
        params,
    })

export const GET_PREMIUM_BLOCKS = async () => {
    return MAIN_SERVER({
        method: 'get',
        url: '/templates/blocks-premium-values',
    })
}

export const GET_BLOCK_TEMPLATES = async (blockTypeId, params) =>
    MAIN_SERVER({
        method: 'get',
        url: `/templates/blocks/${blockTypeId}`,
        params,
    })
